import { StyledButton, StyledIconWrapper, StyledText, StyledWrapper } from "./styles";

import { FC } from "react";
import { PaginationButtonProps } from "./types";
import { useLanguage } from "../../context/LocaleProvider";

const PaginationButton: FC<PaginationButtonProps> = ({
  intent,
  onClick,
  icon,
  isVisible,
  pageNum,
  pagesAmount
}) => {
  const { loadNext, loadPrevious } = useLanguage();

  const buttonText =
    intent === "next"
      ? `${loadNext} ${pageNum + 2}/${pagesAmount}`
      : `${loadPrevious} ${pageNum}/${pagesAmount}`;

  return (
    <StyledWrapper intent={intent}>
      <StyledButton onClick={onClick} isVisible={isVisible}>
        {icon && <StyledIconWrapper>{icon}</StyledIconWrapper>}
        <StyledText>{buttonText}</StyledText>
      </StyledButton>
    </StyledWrapper>
  );
};

export default PaginationButton;
